module.exports = __webpack_public_path__ + "img/fujiwara no mokou.7d6349c3.png";